import React from 'react';
import { LandingTemplate } from '@/components/landing/landingTemplate';
import { GenerateLandingLinkService } from '@/services';
import { landingTextToArtAiConfig } from '@/data/landingConfig/landingTextToArtAiConfig';
import { AggregateSchema } from '../AggregateSchema';
import { schemaObject_TextToArtAi } from './schemaObject';

interface Props {}
const TextToArtAi: React.FC<Props> = () => {
	return (
		<>
			<AggregateSchema schema={schemaObject_TextToArtAi} />
			<LandingTemplate
				data={landingTextToArtAiConfig}
				funnelLinkService={GenerateLandingLinkService.funnelImageGeneratorV2()}
			/>
		</>
	);
};

export default TextToArtAi;
